import React from "react";
import { Phone, MessageCircle, Mail } from "lucide-react";

// Mobile-only sticky-ish quick contacts row used in ClientDetail header.
// Rendered just below the hero on mobile only. Keep deep-link helpers
// inline (same approach used in WeddingMobileAccordion + Events + WD)
// to avoid creating a shared lib in this sprint — extraction is a P2
// cleanup task tracked in the audit reports.
function _cleanPhone(raw) {
  return raw ? String(raw).replace(/[^\d+]/g, "") : "";
}

export default function ContactsQuickRow({ phone, email, name }) {
  const p = _cleanPhone(phone);
  const tel = p ? `tel:${p}` : "";
  const wa = p
    ? `https://wa.me/${p.replace(/^\+/, "")}${name ? `?text=${encodeURIComponent(`Ciao ${name}, ti scrivo per il tuo matrimonio.`)}` : ""}`
    : "";
  const mailto = email ? `mailto:${email}` : "";

  return (
    <div
      className="grid grid-cols-3 gap-2 mt-2"
      data-testid="overview-contacts-quickrow"
    >
      <a
        href={tel || undefined}
        onClick={(e) => { if (!tel) e.preventDefault(); }}
        aria-disabled={!tel}
        className={`flex items-center justify-center gap-1.5 h-12 rounded-md border transition-colors ${
          tel
            ? "bg-emerald-50 border-emerald-200 text-emerald-800 active:bg-emerald-100"
            : "bg-neutral-50 border-neutral-200 text-neutral-300"
        }`}
        data-testid="overview-contact-call"
      >
        <Phone className="w-4 h-4" strokeWidth={1.7} />
        <span className="text-[12px] font-medium uppercase tracking-wide">Chiama</span>
      </a>
      <a
        href={wa || undefined}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => { if (!wa) e.preventDefault(); }}
        aria-disabled={!wa}
        className={`flex items-center justify-center gap-1.5 h-12 rounded-md border transition-colors ${
          wa
            ? "bg-green-50 border-green-200 text-green-800 active:bg-green-100"
            : "bg-neutral-50 border-neutral-200 text-neutral-300"
        }`}
        data-testid="overview-contact-whatsapp"
      >
        <MessageCircle className="w-4 h-4" strokeWidth={1.7} />
        <span className="text-[12px] font-medium uppercase tracking-wide">WhatsApp</span>
      </a>
      <a
        href={mailto || undefined}
        onClick={(e) => { if (!mailto) e.preventDefault(); }}
        aria-disabled={!mailto}
        className={`flex items-center justify-center gap-1.5 h-12 rounded-md border transition-colors ${
          mailto
            ? "bg-blue-50 border-blue-200 text-blue-800 active:bg-blue-100"
            : "bg-neutral-50 border-neutral-200 text-neutral-300"
        }`}
        data-testid="overview-contact-email"
      >
        <Mail className="w-4 h-4" strokeWidth={1.7} />
        <span className="text-[12px] font-medium uppercase tracking-wide">Email</span>
      </a>
    </div>
  );
}
